import { Component, Input, EventEmitter, Output } from '@angular/core';
import { HelperMyRadiant } from '@providers/index';
import { Events, Nav } from 'ionic-angular';
import { TabsPage } from '@pages/dashboard';

/**
 * Generated class for the TreeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'cmp-tomyradiant',
  templateUrl: 'cmp.html'
})
export class tomyradiantComponent {

    @Input() text: any;
    @Input() title: any;
    selected:any = []; 
    clicked:any;
    active_data:any; 
    icon_expanded:any = 'add'; 
    constructor(public helper:HelperMyRadiant,public events:Events,public nav : Nav) {
        this.init();        
    }

    init() {
    }

    backMyRadiant(){
      this.nav.setRoot(TabsPage, {
        tabIndex: 1
      });
      this.events.publish('modul:myradiant');
    }

}



// WEBPACK FOOTER //
// ./src/components/Button/tomyradiant/cmp.ts